export default "__VITE_ASSET__83ffe128__"